import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ProductEnquiryLayer from "../components/ProductEnquiryLayer";
import usePermission from "../hook/usePermission";
import AccessDeniedLayer from "../components/AccessDeniedLayer";

const ProductEnquiryPage = () => {
  const hasPermission = usePermission("productEnquiry", "view");
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Order" header="Product Enquiry" />
        {hasPermission ? <ProductEnquiryLayer /> : <AccessDeniedLayer />}
      </MasterLayout>
    </>
  );
};

export default ProductEnquiryPage;
